// src/services/chat_api.js
import { apiClient } from "./api_client";

const chatApi = {
  /*
  createNewSession: async (token) => {
    try {
      const response = await apiClient.post("/session/new", { token });
      return response.data;
    } catch (error) {
      console.error("Error creating new session:", error);
      return {
        id: "new-session-id",
      };
      //throw error;
    }
  },
  */
  async sendVoiceMessage({ session_id, text }) {
    // TODO: Replace with actual API endpoint
    // return apiClient.post('/chat/voice', { session_id, text }).then(r => r.data);
    // or forward to sendMessage with the transcribed text:
    return chatApi.sendMessage(session_id, text);

    /*
    // Or, for developing, simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    // Return dummy response
    return {
      success: true,
      reply: `You said via voice: "${text}". Session id ${session_id}. This is a dummy response from the bot.`,
      timestamp: new Date().toISOString(),
    };
    */
  },
  sendMessage: async (sessionId, message) => {
    try {
      const response = await apiClient.post("/chat/send", {
        session_id: sessionId,
        message: message,
      });
      return response.data;
    } catch (error) {
      console.error("Error sending message:", error);
      const now = new Date(Date.now());
      const captainMessage = {
        id: Date.now(),
        isResponse: true,
        timestamp: now.toISOString(),
        sender: "user",
        text: "Message not sent. Please try again later.",
      };
      return captainMessage;
      // throw error;
    }
  },
  /*
  getStartText: async () => {
    try {
      const response = await apiClient.get("/chat/start-text");
      return response.data;
    } catch (error) {
      console.error("Error retrieving start text:", error);
      return "Default start text";
      // throw error;
    }
  },
  */
  getChatHistory: async (needNewSession) => {
    try {
      const params = needNewSession
        ? { new_session_needed: true }
        : { new_session_needed: false };
      const response = await apiClient.post("/session/list", params);
      return response.data;
    } catch (error) {
      console.error("Error retrieving chat history:", error);
      throw error;
    }
  },
  /*
  getSessionId: async () => {
    try {
      const response = await apiClient.get("/chat/session");
      return response.data;
    } catch (error) {
      console.error("Error retrieving chat session ID:", error);
      return "Default session ID";
      // throw error;
    }
  },
  */
  getChatAudio: async (chatId) => {
    try {
      const resp = await apiClient.get(`/chat/${chatId}/audio`, {
        responseType: "blob",
      });

      // resp.data is a Blob
      return {
        blob: resp.data,
        contentType: resp.headers?.["content-type"] || "audio/wav",
      };
    } catch (error) {
      console.error("Error fetching chat audio:", error);
      throw error;
    }
  },

  async uploadUserAudio({ session_id, chat_id, blob, contentType }) {
    const form = new FormData();
    form.append("session_id", String(session_id));
    form.append("chat_id", String(chat_id));

    // filename helps backend debugging
    const ext = (contentType || "audio/webm").includes("mp4") ? "m4a" : "webm";
    form.append("audio", blob, `user_${chat_id}.${ext}`);

    const resp = await apiClient.post("/chat/upload_user_audio", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return resp.data;
  },
};

export default chatApi;
